import { Address as LegacyAddress } from '@/services/api/commonTypes';
import { Address as NewAddress } from '@/services/api/contracts/address';

export const mapLegacyAddressToNewFormat = (address: LegacyAddress) => {
  return {
    line1: address.addressLine1,
    line2: address.addressLine2,
    city: address.townCity,
    state: address.stateCounty || "",
    postcode: address.postalCode,
    country: address.country || ""
  };
};

export const mapNewAddressToLegacyFormat = (address: NewAddress) => {
  return {
    addressLine1: address.line1,
    addressLine2: address.line2,
    townCity: address.city,
    stateCounty: address.state || "",
    postalCode: address.postcode,
    country: address.country || ""
  };
};
